import { K1Product } from '@e3dc-react/icons'
import { Box, Button, Card, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import OrderStatus from './OrderStatus'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { OrderStatuses } from '../../models'
import useModals from 'src/Hooks/useModals'
import OrderDetailsCard from './OrderDetailsCard'

interface OrderHistoryCardProps {
  statusTypes: OrderStatuses
  orderId: number
  orderDate: string
  referenceNumber: string | null
  cancelableUntil: string | null
  netAmount: number
  status: string | number
  sapOrderId: number
}

const useStyles = makeStyles()(theme => ({
  productOrderContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  productNumberContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  productNumberIcon: {
    marginRight: theme.spacing(1),
  },
  orderDetailsWrapper: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper2,
  },
  orderDetailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flexWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  detailsButton: {
    textTransform: 'uppercase',
    textDecoration: 'underline',
  },
}))

/*
 * This is the card component that is showing data for each history order
 */
const OrderHistoryCard: React.FC<OrderHistoryCardProps> = ({
  orderId,
  orderDate,
  referenceNumber,
  cancelableUntil,
  netAmount,
  status,
  statusTypes,
  sapOrderId,
}) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { openShopOrderHistoryDetails } = useModals()

  return (
    <Card>
      <Box className={classes.productOrderContainer}>
        <Box className={classes.productNumberContainer}>
          <K1Product className={classes.productNumberIcon} />
          <Typography>{`${t('shop.order-history-card.order-id')}: ${orderId}`}</Typography>
        </Box>
        <OrderStatus statusType={status} statuses={statusTypes} />
      </Box>
      <Card className={classes.orderDetailsWrapper}>
        <Box className={classes.orderDetailsContainer}>
          <OrderDetailsCard orderDate={orderDate} referenceNumber={referenceNumber} cancelableUntil={cancelableUntil} netPrice={netAmount} />
          <Button
            variant="text"
            className={classes.detailsButton}
            onClick={() => {
              openShopOrderHistoryDetails({ orderId: sapOrderId })
            }}
          >
            {t('shop.order-history-card.details-button')}
          </Button>
        </Box>
      </Card>
    </Card>
  )
}

export default OrderHistoryCard
